$(document).ready(function () {
    let uploadProgress = []
    let finishedUploads = []
    let numberOfFiles = []
    let progressBar = document.getElementById('progress-bar')
    let filemanager = document.querySelector('#filemanager')
    let folder = filemanager.dataset.folder
    let dossier = filemanager.dataset.dossier

    // Hide dropzone always when mouse is leaving the window
    document.addEventListener("mouseleave", (event) => {
        if (event.clientY <= 0 || event.clientX <= 0 || (event.clientX >= window.innerWidth || event.clientY >= window.innerHeight)) {
            if (uploadProgress.length == 0) {
                hideDropZone();
            }
        }
    });

    let dropArea = document.defaultView;
    let uploadButton = document.getElementById('uploadButton');
    let fileUploadButton = document.getElementById('file-upload-button');

    if (uploadButton !== undefined && uploadButton !== null) {
        uploadButton.addEventListener('change', handleSelection, false);
        fileUploadButton?.addEventListener('click', () => uploadButton.click());
        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, preventDefaults, false)
        })
        dropArea.addEventListener('drop', handleDrop, false)
        ;['dragenter', 'dragover'].forEach(eventName => {
            dropArea.addEventListener(eventName, showDropzone, false)
        })
    }

    function isFileDrag(e) {
        const dataTransfer = e.dataTransfer;

        if (!dataTransfer) {
            return false;
        }

        const types = Array.from(dataTransfer.types || []);
        const items = Array.from(dataTransfer.items || []);

        return types.includes('Files') || items.some(item => item.kind === 'file');
    }

    function preventDefaults(e) {
        if (!isFileDrag(e)) {
            return;
        }

        e.preventDefault()
        e.stopPropagation()
    }

    function showDropzone(e) {
        if (!isFileDrag(e)) {
            return;
        }

        let dropzone = document.getElementById("dropzone");
        dropzone.style.display = "flex";
    }

    function hideDropZone() {
        let dropzone = document.getElementById("dropzone");
        dropzone.style.display = "none";
    }

    function handleDrop(e) {
        if (!isFileDrag(e)) {
            return;
        }

        let files = e.dataTransfer.files
        if (files.length < 1 && uploadProgress.length === 0) {
            hideDropZone();
        } else {
            handleFiles(files)
        }
    }

    function handleSelection() {
        let dropzone = document.getElementById("dropzone");
        dropzone.style.display = "flex";
        handleFiles(uploadButton.files)
    }

    function handleFiles(files) {
        document.getElementById("dropzone-icon").classList.remove('fa-upload');
        document.getElementById("dropzone-icon").classList.add('fa-spinner');
        document.getElementById("dropzone-icon").classList.add('fa-pulse');

        files = [...files]
        numberOfFiles = files.length

        if (numberOfFiles > 100) {
            alert("Je kan niet meer dan 100 bestanden tegelijk uploaden in een map.");
            hideDropZone();
            return;
        }

        // Loop through all files
        let hasValidFileArray = true;
        files.forEach(file => {
            if (file?.name !== null && file?.name?.endsWith('.zip')) {
                hideDropZone();
                hasValidFileArray = false;
            }

            if (file?.size !== null && file?.size  <= 0) {
                hideDropZone();
                hasValidFileArray = false;
            }
        })

        // If file array is invalid we stop the upload
        if (!hasValidFileArray) {
            showErrorToast()
            return;
        }
        // Initialize the upload progress bar
        initializeProgress(files.length)
        // Loop through the FileList and render image files as thumbnails.
        files.forEach(uploadFile)
    }

    function uploadFile(file, i) {
        let url;
        if (folder > 0) {
            url = '/files/' + dossier + '/upload/' + folder
        } else {
            url = '/files/' + dossier + '/upload'
        }
        let xhr = new XMLHttpRequest()
        let formData = new FormData()
        xhr.open('POST', url, true)
        xhr.setRequestHeader('Accept', 'application/json');  // This line is crucial

        // track upload progress
        xhr.upload.onprogress = function (event) {
            if (event.lengthComputable) {
                updateProgress(i, (event.loaded * 100.0 / event.total) || 100)
            }
        };

        // track completion: both successful or not
        xhr.onloadend = function () {
            if (xhr.status === 200) {
                console.log('file uploaded successfully');
                finalizeUpload(i)
            } else {
                console.log('failed to upload file');


                let response;

                try {
                    response = JSON.parse(xhr.responseText);
                } catch (e) {
                    console.warn("Unexpected XHR response:", xhr.responseText);
                }

                console.warn("Unexpected XHR status:", xhr.status);
                hideDropZone();
                // showFileVirusErrorToast();


                // console.log(response.errors.extension_not_allowed[0]);

                if (
                    response &&
                    response.errors &&
                    response.errors.extension_not_allowed
                ) {
                    // Specific toast for disallowed file type
                    showFileTypeNotAllowedToast(response.errors.extension_not_allowed[0].message);
                } else {
                    // Generic error for other cases
                    showFileVirusErrorToast();
                }

                numberOfFiles = numberOfFiles - 1;
            }
        };

        // track completion: both successful or not
        formData.append('file', file)
        xhr.send(formData)
    }

    function initializeProgress(numFiles) {
        progressBar.style.width = "0%"
        uploadProgress = []
        for (let i = numFiles; i > 0; i--) {
            uploadProgress.push(0)
        }
    }

    function updateProgress(fileNumber, percent) {
        uploadProgress[fileNumber] = percent
        // Calculate the total progress of the upload(sum of all files)
        let total = uploadProgress.reduce((tot, curr) => tot + curr, 0) / uploadProgress.length
        progressBar.style.width = total + "%"
    }

    function finalizeUpload(fileNumber) {
        finishedUploads.push(fileNumber)

        if (finishedUploads.length === numberOfFiles) {
            setTimeout(function () {
                location.reload();
            }, 1000);
        }
    }

    function showErrorToast() {
        /** Custom alert box for incorrect file uploads */
        window.alert = () => {
            let target;

            /** Check if event object is available */
            if (event) {
                event.preventDefault();
                target = $(event.target);
            }
            let modal = $(target ? target.data('confirm-modal') ?? '#js-confirm-modal' : '#js-confirm-modal');
            modal.find('.modal-body .text').html('Een of meerdere van de geüploade bestanden zijn niet geldig. ' +
                'Probeer het opnieuw. <br/><br/>Probeert u direct vanuit een <strong>.zip</strong> of <strong>.rar</strong> bestand te uploaden? ' +
                'Pak het <strong>.zip</strong> of <strong>.rar</strong> bestand eerst lokaal uit en upload de uitgepakte bestanden naar Digidos.');
            modal.find('button').hide();
            modal.find('button.confirm').show();
            modal.find('button.confirm').html('Sluiten');
            modal.find('button.confirm').click(function () {
                modal.modal('hide');
                setTimeout(function () {
                    window.location.reload();
                }, 200);
            });
            modal.modal('show');
        };
        alert();
    }

    function showFileVirusErrorToast() {
        /** Custom alert box for incorrect file uploads */
        window.alert = () => {
            let target;

            /** Check if event object is available */
            if (event) {
                event.preventDefault();
                target = $(event.target);
            }
            let modal = $(target ? target.data('confirm-modal') ?? '#js-confirm-modal' : '#js-confirm-modal');
            // give me an error message in dutch for virus scanner
            modal.find('.modal-body .text').html(`
        <div style="font-size: 1rem; line-height: 1.6;">
            <h5 style="margin-top: 0; font-weight: bold; color: #014c73;">
                <i class="fa fa-ban" style="margin-right: 8px;"></i>
                Upload geblokkeerd
            </h5>
            <p>Een of meerdere bestanden zijn geblokkeerd door onze beveiligingscontrole.</p>
            <p>
                Onze <strong>virusscanner</strong> heeft een mogelijk risico gevonden in één van de bestanden.
                Uit voorzorg is het uploadproces gestopt.
            </p>
            <p><strong>Wat kan je doen?</strong></p>
            <ul style="padding-left: 1.2em; margin: 0;">
                <li style="margin-bottom: 0.5em;">Controleer of het bestand afkomstig is van een betrouwbare bron.</li>
                <li style="margin-bottom: 0.5em;">Sleep het bestand uit Windows Verkenner, Finder op Mac of druk op de uploaden knop en selecteer het bestand. Voorkom dat er gesleept wordt uit een andere applicatie, dit kan ervoor zorgen dat de controle mislukt.</li>
                <li style="margin-bottom: 0.5em;">Verwijder verdachte bestanden en probeer het opnieuw.</li>
                <li style="margin-bottom: 0.5em;">Neem contact op met je systeembeheerder als je denkt dat dit een vergissing is. Geef hierbij aan welk extensietype er in het rood staat aangegeven, zodat we dit kunnen controleren.</li>
            </ul>
        </div>
    `);
            modal.find('button').hide();
            modal.find('button.confirm').show();
            modal.find('button.confirm').html('Sluiten');
            modal.find('button.confirm').click(function () {
                modal.modal('hide');
                setTimeout(function () {
                    window.location.reload();
                }, 200);
            });
            modal.modal('show');
        };
        alert();
    }

    function showFileTypeNotAllowedToast(message) {
        /** Custom alert box for incorrect file uploads */
        window.alert = () => {
            let target;

            /** Check if event object is available */
            if (event) {
                event.preventDefault();
                target = $(event.target);
            }
            let modal = $(target ? target.data('confirm-modal') ?? '#js-confirm-modal' : '#js-confirm-modal');
            modal.find('.modal-body .text').html(`
        <div style="font-size: 1rem; line-height: 1.6;">
            <h5 style="margin-top: 0; font-weight: bold; color: #014c73;">
                <i class="fa fa-ban" style="margin-right: 8px;"></i>
                Upload geblokkeerd
            </h5>
            <p>Een of meerdere bestanden zijn geblokkeerd door onze beveiligingscontrole.</p>
              <p style="color: red;"> <!-- Make the message red -->
                    ${message}
              </p>
            <p>
                Het bestandstype dat je probeert te uploaden is niet toegestaan.
                Dit kan komen door een beveiligingsinstelling van de server.
            </p>
            <p><strong>Wat kan je doen?</strong></p>
            <ul style="padding-left: 1.2em; margin: 0;">
                <li style="margin-bottom: 0.5em;">Controleer of het bestandstype dat je probeert te uploaden correct is.</li>
                <li style="margin-bottom: 0.5em;">Sleep het bestand uit Windows Verkenner, Finder op Mac of druk op de uploaden knop en selecteer het bestand. Voorkom dat er gesleept wordt uit een andere applicatie, dit kan ervoor zorgen dat de controle mislukt.</li>
                <li style="margin-bottom: 0.5em;">Neem contact op met je systeembeheerder als je denkt dat dit een vergissing is. Geef hierbij aan welk extensietype er in het rood staat aangegeven, zodat we dit kunnen controleren.</li>
            </ul>
        </div>
    `);
            modal.find('button').hide();
            modal.find('button.confirm').show();
            modal.find('button.confirm').html('Sluiten');
            modal.find('button.confirm').click(function () {
                modal.modal('hide');
                setTimeout(function () {
                    window.location.reload();
                }, 200);
            });
            modal.modal('show');
        };
        alert();
    }
});
